module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/placeholder-c75c0759906993a55890313bf2bf6963.svg";